<p-dialog header="{{header}}" [(visible)]="visible" [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" (onHide)="onHideDialog()">
    <p class="p-m-0">{{message}}</p>
    <ng-template pTemplate="footer">
        <app-audi-button text="OK" (click)="onCloseDialog()"></app-audi-button>
    </ng-template>
</p-dialog>